// Only get students that are enrolled in the food program if isEnrolledInFoodProgram is true,
// otheriwse, get all students
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useMemo } from 'react';

import { FoodProgramTierEnum } from '../common/enums';
import useRooms from '../hooks/useRooms';
import { useAllStudents } from '../students/studentsHooks';

const VALID_FOOD_PROGRAM_TIERS = [FoodProgramTierEnum.TIER_1, FoodProgramTierEnum.TIER_2];

export function useStudentsMap(isEnrolledInFoodProgram?: boolean): Record<string, any> {
  const { list: students } = useAllStudents();
  const { foodProgramEnabled } = useFlags();

  const studentsMap = useMemo(() => {
    return (
      students?.reduce((acc, student) => {
        if (
          foodProgramEnabled &&
          !!isEnrolledInFoodProgram &&
          !VALID_FOOD_PROGRAM_TIERS.includes(student.foodProgramTier)
        )
          return acc;
        acc[student.id] = student;
        return acc;
      }, {}) ?? {}
    );
  }, [foodProgramEnabled, isEnrolledInFoodProgram, students]);
  return studentsMap;
}

export function useRoomsMap(): Record<string, any> {
  const rooms = useRooms();
  const roomsMap = useMemo(() => {
    return (
      rooms?.reduce((acc, room) => {
        acc[room.id] = room;
        return acc;
      }, {}) ?? {}
    );
  }, [rooms]);
  return roomsMap;
}
